unit PrjFormTLNReportSelection;

interface

uses
  System.SysUtils,
  System.Classes,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Controls,
  Vcl.Imaging.GIFImg,
  Vcl.Menus,
  Vcl.CheckLst,

  JS,
  Web,

  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WEBLib.StdCtrls,
  WEBLib.Menus,
  WEBLib.ExtCtrls,
  WEBLib.CheckLst,
  PrjFormPDFDisplay,

  PrjFormDefault;


type
  THelperClass = class;

  TPrjFormsTLNReportSelection = class(TPrjFormsDefault)
    PopupMenu: TPopupMenu;
    mnAlleMarkieren: TMenuItem;
    Allemarkieren1: TMenuItem;
    mnAlleDemarkieren: TMenuItem;
    chkListBoxKH1: TCheckListBox;
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    spedKrankenhaus: TSpinEdit;
    lblKrankenhaus: TLabel;
    WebMessageDlg: TMessageDlg;
    procedure Allemarkieren1Click(Sender: TObject);
    procedure Allemarkieren2Click(Sender: TObject);

    procedure btnPrintClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure spedKrankenhausChange(Sender: TObject);
    procedure spedPeriodeChange(Sender: TObject);
  strict private
    FExternalBrowser : Boolean;
    function GenerateReportList(ATarget: Integer): string;
  private
    FReportSelectList   : array [1..10] OF BOOLEAN;
    { Private-Deklarationen }
  public
    [Async]
    function Init: Boolean; async; virtual;
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

  THelperClass = class(TObject)
  private
    Tag: Integer;
  end;

const
  CNoReportSelectedMsg = 'Es wurde kein Bericht zum drucken ausgewählt';

var
  PrjFormsTLNReportSelection: TPrjFormsTLNReportSelection;

implementation

{$R *.dfm}


uses
  wxBaseClassWebTools,

  HBMWebData,
  HBMWebDef;


procedure TPrjFormsTLNReportSelection.Allemarkieren1Click(Sender: TObject);
var Lidx : integer;
begin
  for Lidx := 0 to chkListBoxKH1.Items.Count - 1 do
  begin
    chkListBoxKH1.Checked[lidx] := true;
  end;
end;

procedure TPrjFormsTLNReportSelection.Allemarkieren2Click(Sender: TObject);
var Lidx : integer;
begin
  for Lidx := 0 to chkListBoxKH1.Items.Count - 1 do
  begin
    chkListBoxKH1.Checked[lidx] := false;
  end;
end;

procedure TPrjFormsTLNReportSelection.btnCloseClick(Sender: TObject);
begin
  close;
end;

procedure TPrjFormsTLNReportSelection.btnPrintClick(Sender: TObject);
var LPdfURL             : string;
var LUserID             : string;
//var LPeriode            : integer;
var LReportType         : integer;
var LToken              : string;
var LPrjFormsPDFDisplay : TPrjFormsPDFDisplay;
var LPayLoad            : TStringList;


  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjFormsPDFDisplay) and (LPrjFormsPDFDisplay is TPrjFormsPDFDisplay) then
    begin
      window.location.hash  := 'LPrjFormsPDFDisplay';  // used to manage Back button handling to close subform
      ( LPrjFormsPDFDisplay as TPrjFormsPDFDisplay ).Init;
      ( LPrjFormsPDFDisplay as TPrjFormsPDFDisplay ).Caption  := 'Reporting';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin

  end;

  procedure  ShowPDFReport(AUrl : string);
  begin
      asm
        var popup = window.open(AUrl, '_blank');  //from Demos\PDFView
        setTimeout(function(){popup.document.title=name;}, 200);
      end;
  end;
begin
  LToken    := DataModule.TokenInformation.OriginalToken;
  LPayLoad  := TStringList.Create;

  LPayLoad.Add(spedPeriode.Value.ToString);
  LPayLoad.Add(spedKrankenhaus.Value.ToString);
  LPayLoad.Add('-1');
  LPayLoad.Add('-1');


  if GenerateReportList(2) <> '' then
  begin
    LPayLoad.Add(GenerateReportList(2));

    if FormIdentifier = wxFrmPrintTLNReports then
    begin
      if DataModule.TokenInformation.isSpielleiter then
      begin
        LPayLoad.Add('TLN');
        LPayLoad.Add('0');
      end else
      begin
        LPayLoad.Add('SPL');
        LPayLoad.Add('1');
      end;

      if DataModule.HBMDefaultData.AktuellePeriode < DataModule.HBMDefaultData.Vorkalkulation then
      begin

        LPdfURL := cXDataServerUrl +  'DataServices/RequestReport?' +
                                      'ASimulationID=' + DataAccess.AktuelleSimulation.ToString + '&' +
                                      'AUserID=' + DataModule.TokenInformation.UserName + '&' +
                                      'AFunctionID=' + 'P' + '&' +
                                      'APayload=' + LPayLoad.CommaText + '&' +
                                      'ASubFunction=' + '-' + '&' +
                                      'AToken=' + LToken;
      end else
      begin
        LPdfURL := cXDataServerUrl +  'DataServices/RequestReport?' +
                                      'ASimulationID=' + DataAccess.AktuelleSimulation.ToString + '&' +
                                      'AUserID=' + DataModule.TokenInformation.UserName + '&' +
                                      'AFunctionID=' + 'P' + '&' +
                                      'APayload=' + LPayLoad.CommaText + '&' +
                                      'ASubFunction=' + '-' + '&' +
                                      'AToken=' + LToken;
      end;
    end else if FormIdentifier = wxFrmPrintSPLReports then
    begin
      LPayLoad.Add('SPL');
      LPayLoad.Add('1');
      LPdfURL := cXDataServerUrl +  'DataServices/RequestReport?' +
                                    'ASimulationID=' + DataAccess.AktuelleSimulation.ToString + '&' +
                                    'AUserID=' + DataModule.TokenInformation.UserName + '&' +
                                    'AFunctionID=' + 'P' + '&' +
                                    'APayload=' + LPayLoad.CommaText + '&' +
                                    'ASubFunction=' + '-' + '&' +
                                    'AToken=' + LToken;
    end;
    FExternalBrowser := true;

//    FExternalBrowser := False;

    if FExternalBrowser then
    begin
//      ShowPDFReport(LPdfURL);
      Application.Navigate(LPdfURL);

    end else
    begin
      LPrjFormsPDFDisplay              := TPrjFormsPDFDisplay.CreateNew(@AfterCreate);
      LPrjFormsPDFDisplay.Popup        := true;
      LPrjFormsPDFDisplay.PopupOpacity := 0.2;
      LPrjFormsPDFDisplay.ShowModal(@AfterShowModal);
    end;
  end else
  begin
    WebMessageDlg.ShowDialog(CNoReportSelectedMsg, mtConfirmation, [mbOK]);
  end;
end;

function TPrjFormsTLNReportSelection.GenerateReportList(ATarget: Integer): string;
var LHelpStr      : string;
var LIdx          : Integer;
var LHelperClass  : THelperClass;

  function FillReportSelectList : Boolean;
  var LIdx1 : Integer;
  begin
    for LIdx1 := 1 to chkListBoxKH1.Items.Count - 1 do
      FReportSelectList[LIdx1]:= False;

    Result := false;
    for LIdx1 := 0 to chkListBoxKH1.Items.Count - 1 do
    begin
      LHelperClass := THelperClass(chkListBoxKH1.Items.Objects[LIdx1]);
      if (LHelperClass.Tag mod 10 <> 0) and (LHelperClass.Tag div 10 > 0) then
      begin
        if chkListBoxKH1.Checked[LIdx1] then
        begin
          FReportSelectList[LHelperClass.Tag div 10] := True;
          Result := true;
        end;
      end;
    end;
  end;
begin
  Result := '';
  if FillReportSelectList then
  begin
    LHelpStr := '';
    for LIdx := 1 to 12 do
      if FReportSelectList[LIdx] then
        LHelpStr := LHelpStr + CHAR(64 + LIdx);

    if LHelpStr <> ''  then
    begin
      if ATarget = 0 then  //0 = Out_ZielScreen
      begin
      end;
      if ATarget = 2 then  //2 = Out_ZielFile
      begin
        result := LHelpStr;
      end;
    end else
    begin
    end;
  end;
end;

function TPrjFormsTLNReportSelection.Init: Boolean;
var LHelperClass : THelperClass;
begin
  if FormIdentifier = wxFrmPrintTLNReports then
  begin
    chkListBoxKH1.Items.Clear;
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 11;
    chkListBoxKH1.AddItem('Erlöse des Krankenhause', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 21;
    chkListBoxKH1.AddItem('Leistungsdaten des Geschäftsjahres', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 31;
    chkListBoxKH1.AddItem('Betten Controlling', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 41;
    chkListBoxKH1.AddItem('Kostenartenrechnung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 51;
    chkListBoxKH1.AddItem('Kostenstellenrechnung / ILV', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 61;
    chkListBoxKH1.AddItem('Kostenträgerrechnung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 71;
    chkListBoxKH1.AddItem('Deckungsbeitragrechnung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 81;
    chkListBoxKH1.AddItem('Personalberichte', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 91;
    chkListBoxKH1.AddItem('Gewinn- und Verlustrechnung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 101;
    chkListBoxKH1.AddItem('Finanzbericht / Bilanz', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 111;
    chkListBoxKH1.AddItem('Marktforschung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
//    LHelperClass.Tag := 121;
//    chkListBoxKH1.AddItem('E-Datenprotokoll 1 + 2', TObject(LHelperClass));
  end else if FormIdentifier = wxFrmPrintSPLReports then
  begin
    chkListBoxKH1.Items.Clear;
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 11;
    chkListBoxKH1.AddItem('Bericht 1', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 21;
    chkListBoxKH1.AddItem('Bericht 2', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 31;
    chkListBoxKH1.AddItem('Bericht 3', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 41;
    chkListBoxKH1.AddItem('KPI', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 51;
    chkListBoxKH1.AddItem('Marktmodell Gesamtpotential', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 61;
    chkListBoxKH1.AddItem('Marktmodel Kurven', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 71;
    chkListBoxKH1.AddItem('Marktmodell Normierung', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 81;
    chkListBoxKH1.AddItem('Marktmodel Überhänge', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
    LHelperClass.Tag := 91;
    chkListBoxKH1.AddItem('Marktmodell MVZ Patienten', TObject(LHelperClass));
    LHelperClass := THelperClass.Create;
//    LHelperClass.Tag := 101;
//    chkListBoxKH1.AddItem('Spielleiter Daten', TObject(LHelperClass));
  end;

  spedKrankenhaus.Value     := DataModule.HBMDefaultData.AktuellesUnternehmen;
  spedKrankenhaus.MaxValue  := DataModule.HBMDefaultData.MaxAnzUnternehmen;
  spedKrankenhaus.MinValue  := DataModule.HBMDefaultData.MinAnzUnternehmen;

  spedPeriode.Value         := DataModule.HBMDefaultData.AktuellePeriode;
  spedPeriode.MaxValue      := 9;
  spedPeriode.MinValue      := 0;

  spedPeriode.Enabled       := DataModule.TokenInformation.isSpielleiter and (FormIdentifier = wxFrmPrintTLNReports);
  spedKrankenhaus.Enabled   := DataModule.TokenInformation.isSpielleiter and (FormIdentifier = wxFrmPrintTLNReports);

  spedKrankenhausChange(Self);
  spedPeriodeChange(Self);
end;

procedure TPrjFormsTLNReportSelection.spedKrankenhausChange(Sender: TObject);
begin
  lblKrankenhaus.Caption  := 'Krankenhaus ' + Round(spedKrankenhaus.Value).ToString;
end;

procedure TPrjFormsTLNReportSelection.spedPeriodeChange(Sender: TObject);
begin
  lblPeriode.Caption  := 'Geschäftsjahr ' + Round(spedPeriode.Value).ToString;
end;

procedure TPrjFormsTLNReportSelection.LoadDFMValues;
begin
  inherited LoadDFMValues;

  chkListBoxKH1 := TCheckListBox.Create('reportCheckList');
  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPrintPeriode');
  lblKrankenhaus := TLabel.Create('LabelNAVPrintKrankenhaus');
  btnClose := TButton.Create('btnNAVPrintBack');
  btnSave := TButton.Create('btnNAVPrintSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPrintPeriode');
  btnPrint := TButton.Create('btnNAVPrintPrint');
  btnCancel := TButton.Create('btnNAVPrintCancel');
  brnHelp := TButton.Create('btnNAVPrintHelp');
  spedKrankenhaus := TSpinEdit.Create('SpinEdNAVPrintKrankenhaus');
  WebMessageDlg := TMessageDlg.Create(Self);
  PopupMenu := TPopupMenu.Create(Self);
  mnAlleMarkieren := TMenuItem.Create(Self);
  Allemarkieren1 := TMenuItem.Create(Self);
  mnAlleDemarkieren := TMenuItem.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  chkListBoxKH1.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  lblKrankenhaus.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  spedKrankenhaus.BeforeLoadDFMValues;
  WebMessageDlg.BeforeLoadDFMValues;
  PopupMenu.BeforeLoadDFMValues;
  mnAlleMarkieren.BeforeLoadDFMValues;
  Allemarkieren1.BeforeLoadDFMValues;
  mnAlleDemarkieren.BeforeLoadDFMValues;
  try
    Width := 955;
    Height := 749;
    ElementClassName := '!w-full !h-full !flex !justify-center !items-center !top-0 !left-0 bg-[#0008]';
    WaitMessage.Picture.LoadFromFile('PrjFormTLNReportSelection.WaitMessage.Picture.gif');
    chkListBoxKH1.SetParentComponent(Self);
    chkListBoxKH1.Name := 'chkListBoxKH1';
    chkListBoxKH1.Left := 0;
    chkListBoxKH1.Top := 0;
    chkListBoxKH1.Width := 683;
    chkListBoxKH1.Height := 749;
    chkListBoxKH1.Align := alClient;
    chkListBoxKH1.ElementCheckClassName := 'checkbox me-2';
    chkListBoxKH1.ElementItemClassName := 'form-check';
    chkListBoxKH1.ElementFont := efCSS;
    chkListBoxKH1.ElementPosition := epRelative;
    chkListBoxKH1.HeightStyle := ssAuto;
    chkListBoxKH1.HeightPercent := 100.00000000000000000;
    chkListBoxKH1.ItemHeight := 18;
    chkListBoxKH1.PopupMenu := PopupMenu;
    chkListBoxKH1.TabOrder := 1;
    chkListBoxKH1.WidthStyle := ssAuto;
    chkListBoxKH1.WidthPercent := 100.00000000000000000;
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 683;
    pnLeftNavigation.Top := 0;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 749;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Align := alRight;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 2;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 17;
    lblPeriode.Top := 240;
    lblPeriode.Width := 165;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftsjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    lblKrankenhaus.SetParentComponent(pnLeftNavigation);
    lblKrankenhaus.Name := 'lblKrankenhaus';
    lblKrankenhaus.Left := 17;
    lblKrankenhaus.Top := 352;
    lblKrankenhaus.Width := 155;
    lblKrankenhaus.Height := 29;
    lblKrankenhaus.Caption := 'Krankenhaus';
    lblKrankenhaus.ElementFont := efCSS;
    lblKrankenhaus.ElementPosition := epRelative;
    lblKrankenhaus.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus.Font.Color := clWindowText;
    lblKrankenhaus.Font.Height := -24;
    lblKrankenhaus.Font.Name := 'Tahoma';
    lblKrankenhaus.Font.Style := [fsBold];
    lblKrankenhaus.HeightStyle := ssAuto;
    lblKrankenhaus.HeightPercent := 100.00000000000000000;
    lblKrankenhaus.ParentFont := False;
    lblKrankenhaus.WidthStyle := ssAuto;
    lblKrankenhaus.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 13;
    btnClose.Top := 35;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 13;
    btnSave.Top := 116;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.Visible := False;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 19;
    spedPeriode.Top := 275;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.ElementClassName := 'input input-bordered w-full';
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    SetEvent(spedPeriode, Self, 'OnChange', 'spedPeriodeChange');
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 6;
    btnPrint.Top := 499;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    SetEvent(btnPrint, Self, 'OnClick', 'btnPrintClick');
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 13;
    btnCancel.Top := 594;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.Visible := False;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 13;
    brnHelp.Top := 684;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.Visible := False;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    spedKrankenhaus.SetParentComponent(pnLeftNavigation);
    spedKrankenhaus.Name := 'spedKrankenhaus';
    spedKrankenhaus.Left := 19;
    spedKrankenhaus.Top := 387;
    spedKrankenhaus.Width := 250;
    spedKrankenhaus.Height := 57;
    spedKrankenhaus.ElementClassName := 'input input-bordered w-full';
    spedKrankenhaus.HeightStyle := ssAuto;
    spedKrankenhaus.WidthStyle := ssAuto;
    spedKrankenhaus.AutoSize := False;
    spedKrankenhaus.BorderStyle := bsSingle;
    spedKrankenhaus.ChildOrder := 7;
    spedKrankenhaus.Color := clWhite;
    spedKrankenhaus.ElementFont := efCSS;
    spedKrankenhaus.ElementPosition := epRelative;
    spedKrankenhaus.Increment := 1;
    spedKrankenhaus.MaxValue := 100;
    spedKrankenhaus.MinValue := 0;
    spedKrankenhaus.Role := '';
    spedKrankenhaus.Value := 0;
    SetEvent(spedKrankenhaus, Self, 'OnChange', 'spedKrankenhausChange');
    WebMessageDlg.SetParentComponent(Self);
    WebMessageDlg.Name := 'WebMessageDlg';
    WebMessageDlg.Left := 56;
    WebMessageDlg.Top := 129;
    WebMessageDlg.Width := 24;
    WebMessageDlg.Height := 24;
    WebMessageDlg.Buttons := [];
    WebMessageDlg.Opacity := 0.20000000000000000;
    WebMessageDlg.ElementButtonClassName := 'btn';
    WebMessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg.ElementTitleClassName := 'text-body';
    WebMessageDlg.ElementContentClassName := 'text-body';
    PopupMenu.SetParentComponent(Self);
    PopupMenu.Name := 'PopupMenu';
    PopupMenu.Appearance.HamburgerMenu.Caption := 'Menu';
    PopupMenu.Appearance.SubmenuIndicator := '&#9658;';
    PopupMenu.Font.Charset := DEFAULT_CHARSET;
    PopupMenu.Font.Color := clWindowText;
    PopupMenu.Font.Height := -12;
    PopupMenu.Font.Name := 'Segoe UI';
    PopupMenu.Font.Style := [];
    PopupMenu.Left := 120;
    PopupMenu.Top := 376;
    mnAlleMarkieren.SetParentComponent(PopupMenu);
    mnAlleMarkieren.Name := 'mnAlleMarkieren';
    mnAlleMarkieren.Caption := 'Alle markieren';
    SetEvent(mnAlleMarkieren, Self, 'OnClick', 'Allemarkieren1Click');
    Allemarkieren1.SetParentComponent(PopupMenu);
    Allemarkieren1.Name := 'Allemarkieren1';
    Allemarkieren1.Caption := '-';
    mnAlleDemarkieren.SetParentComponent(PopupMenu);
    mnAlleDemarkieren.Name := 'mnAlleDemarkieren';
    mnAlleDemarkieren.Caption := 'Alle Demarkieren';
    SetEvent(mnAlleDemarkieren, Self, 'OnClick', 'Allemarkieren2Click');
  finally
    WaitMessage.AfterLoadDFMValues;
    chkListBoxKH1.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    lblKrankenhaus.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    spedKrankenhaus.AfterLoadDFMValues;
    WebMessageDlg.AfterLoadDFMValues;
    PopupMenu.AfterLoadDFMValues;
    mnAlleMarkieren.AfterLoadDFMValues;
    Allemarkieren1.AfterLoadDFMValues;
    mnAlleDemarkieren.AfterLoadDFMValues;
  end;
end;

end.
